module.exports = __webpack_public_path__ + "static/media/MarkerPredicRed.3a342c46.svg";